import { getEnv } from 'mobx-easy';
import { RootEnv } from '../helpers/create-store';

export const useTranslation = () => {
	const t = (key: string, args: object = {}): string => {
		return getEnv<RootEnv>().langService.translate(key, args);
	};

	return { t };
};
